import Vue from "vue";
import api from "@/api";

export default {
	actions: {
		async GetCourseList() {
			let response = await Vue.axios({
				method: "GET",
				url: api.GetCourseList,
			});
			return response.data;
		},
		async GetCourse(_, entryId) {
			let response = await Vue.axios({
				method: "GET",
				url: api.GetCourse + entryId,
				data: entryId,
			});
			return response.data;
		},
		async CreateCourse(_, entry) {
			let response = await Vue.axios({
				method: "POST",
				url: api.CreateCourse,
				data: entry,
			});

			return response.data;
		},
		async UpdateCourse(_, entry) {
			let response = await Vue.axios({
				method: "POST",
				url: api.UpdateCourse,
				data: entry,
			});
			return response.data;
		},
		async DeleteCourse(_, entry) {
			let response = await Vue.axios({
				method: "POST",
				url: api.DeleteCourse,
				data: entry,
			});
			return response.data;
		},
	},
};
